<template>
  <div>
    <template v-for="(option, index) in options">
      <label :key="index" class="l-radio is-bold" :class="{'is-selected' : checked == option.value}">
        <input
          type="radio"
          :value="option.value"
          :checked="checked == option.value"
          :disabled="disabled"
          @change="updateValue"
        />{{ option.label }}
      </label>
    </template>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked', // v-bind:checked
    event: 'input' // v-on:input
  },
  props: {
    options: {
      type: Array,
    },
    checked: {},
    disabled: {
      default: false
    },
  },
  methods: {
    updateValue: function(e) {
      this.$emit("input", e.target.value);
    }
  }
}
</script>